import gifLoader from "../assets/images/main/preloader.gif";

const Loader = () => {
  const handleError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const target = e.target;
    if (target instanceof HTMLImageElement) {
      target.onerror = null; // Prevent infinite loop if the fallback image also fails
      target.src = gifLoader; // Set fallback image source
    }
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: "250px",
      }}
    >
      {/* <CircularProgress /> */}
      <img
        style={{ height: "65px", width: "65px" }}
        src={gifLoader}
        onError={handleError}
        alt="preloader"
      />
    </div>
  );
};

export default Loader;
